import { ApolloError } from '@apollo/client'
import { openIntercom } from '@salescore/client-base'
import { Card } from 'antd'
import { createContext, type ReactNode, Suspense, useContext, useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

export const ApolloErrorComponentContext = createContext<
  ({ error, isSmallComponent }: { error: ApolloError; isSmallComponent?: boolean }) => HandledError
>(() => {
  throw new Error('ApolloErrorComponentContext is not initialized')
})

// eslint-disable-next-line sonarjs/todo-tag
// TODO: isSmallComponentのフラグを渡すのではなくて別のコンポーネントにする
export const HandleQuery = ({
  children,
  loadingElement,
  isSmallComponent,
}: {
  children: ReactNode
  loadingElement?: ReactNode
  isSmallComponent?: boolean
}): ReactNode => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      if (error instanceof ApolloError) {
        return <ApolloErrorComponent error={error} isSmallComponent={isSmallComponent} />
      } else if (error instanceof Error) {
        return <span>Error: {error.message}</span>
      } else {
        return <span>something went wrong</span>
      }
    }}
  >
    <Suspense fallback={loadingElement ?? <></>}>{children}</Suspense>
  </ErrorBoundary>
)

function ApolloErrorComponent({
  error,
  isSmallComponent,
}: {
  error: ApolloError
  isSmallComponent?: boolean
}): ReactNode {
  openIntercom({})
  const useHandleApolloError = useContext(ApolloErrorComponentContext)
  // eslint-disable-next-line sonarjs/todo-tag
  // TODO: errorProviderに依存しない方が良い？
  const { component, effect } = useHandleApolloError({ error, isSmallComponent })

  useEffect(() => {
    if (effect !== undefined) {
      effect()
    }
  }, [])

  // eslint-disable-next-line sonarjs/todo-tag
  // TODO: エラー表示まともにしたい
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  return isSmallComponent ? (
    <>{component}</>
  ) : (
    <div className="mt-16 flex justify-center align-middle">
      <Card style={{ width: 620 }}>{component}</Card>
    </div>
  )
}

export interface HandledError {
  component: ReactNode
  effect?: () => void
}
